import store from "../../../../../store/store";

export const componentKey = 'MASTER_ALLERGY';

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setMasterAllergyList: (state, action) => {
            state.masterAllergyData = action.payload;
        }, 
        setOpenAddAllergyModal: (state, action) => {
            state.isOpenAddAllergyModal = action.payload;
        }
    },
    initialReducerState: {
        masterAllergyData: [],
        isOpenAddAllergyModal: false,
    },
});

export const { setMasterAllergyList,setOpenAddAllergyModal } = actions;
